import React from 'react';

interface IProps {
  message: string;
}

const StepPlaceholderMessage = ({ message }: IProps) => {
  return <h2 className="text-lg lg:text-xl text-center mt-10">{message}</h2>;
};

export default StepPlaceholderMessage;
